<template>
  <v-dialog
    scrollable
    maxWidth="90%"
    width="500"
    v-model="core.matchingDialog.visible"
    :persistent="true"
    :style="`z-index: ${this.core.confirmationIndex - 1};position: fixed;`"
  >
    <v-card>
      <v-toolbar dark color="primary"
        >{{
          core.matchingDialog.isCopy &&
          core.currentSelectedTableItem &&
          core.currentSelectedTableItem["index"]
            ? $t("common.matchDialog.matchCopyToSelectedItem") +
              ": " +
              core.currentSelectedTableItem.index
            : $t("common.matchDialog.matchAddNewLocation")
        }}
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click.stop="
            core.tour2.runAddNCopyDataSteps({
              isAdd: !core.matchingDialog.isCopy,
            });
            notAllowBackdropClose = true;
            setDialogPersistent();
          "
          ><v-icon>mdi-help-circle</v-icon></v-btn
        >
        <v-btn icon @click="core.matchingDialog.visible = false"
          ><v-icon>close</v-icon></v-btn
        >
      </v-toolbar>
      <v-card-title></v-card-title>
      <v-card-text>
        <v-container fluid id="Add-And-Copy">
          <v-row>
            <v-col cols="12">
              <div v-if="!showMatchField">
                {{ $t("common.matchDialog.matchCopyToCoordinate") }}
              </div>
              <v-switch
                v-else
                v-model="enableCoordinate"
                color="success"
                :label="$t('common.matchDialog.matchCopyToCoordinate')"
              ></v-switch>
              <v-card
                v-if="
                  core.matchingDialog.data && core.matchingDialog.data.latLng
                "
                :disabled="enableCoordinate ? false : true"
              >
                <v-container>
                  <v-layout>
                    <v-flex xs6 md6>
                      <div class="FieldTitle">
                        {{
                          $t("common.latitude") + ", " + $t("common.longitude")
                        }}:
                      </div>
                      <div>
                        {{
                          core.displayXY(core.matchingDialog.data.latLng).lat
                        }}
                      </div>
                      <div>
                        {{
                          core.displayXY(core.matchingDialog.data.latLng).lng
                        }}
                      </div>
                    </v-flex>
                    <v-flex xs6 md6>
                      <div class="FieldTitle">
                        {{ $t("common.hk80y") + ", " + $t("common.hk80x") }}:
                      </div>
                      <div>
                        {{
                          core.displayHK80(core.matchingDialog.data.latLng)[1]
                        }}
                      </div>
                      <div>
                        {{
                          core.displayHK80(core.matchingDialog.data.latLng)[0]
                        }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-col>

            <v-col v-if="core.matchingDialog.showAdvanced" cols="12">
              <v-switch
                v-model="enableMatching"
                color="success"
                :label="$t('common.matchDialog.matchAdvancedOption')"
              >
              </v-switch>
            </v-col>

            <v-col
              cols="12"
              v-if="enableMatching && core.matchingDialog.showAdvanced"
            >
              <v-container>
                <v-row>
                  <v-col class="text-center" cols="6">
                    {{ $t("common.matchDialog.matchFields") }}
                  </v-col>
                  <v-col class="text-center" cols="6">
                    <v-btn
                      small
                      color="primary"
                      @click="core.manageColumnModal = true"
                      ><v-icon small>mdi-wrench</v-icon
                      >{{
                        this.$vuetify.breakpoint.name != "xs"
                          ? $t("common.manageColumns")
                          : $t("common.manageColumnsShortForm")
                      }}</v-btn
                    >
                    <!-- hide title <v-btn
                          small
                          :title="$t('common.title_tableManageColumns')"
                          color="primary"
                          @click="core.manageColumnModal = true"
                          ><v-icon small>mdi-wrench</v-icon
                          >{{ $t("common.manageColumns") }}</v-btn
                        > -->
                  </v-col>
                </v-row>
              </v-container>

              <v-card :disabled="enableMatching ? false : true">
                <v-container>
                  <v-layout>
                    <v-flex xs12 center>{{
                      $t("common.matchDialog.matchFieldsTitle")
                    }}</v-flex>
                  </v-layout>
                  <v-layout
                    v-if="
                      core.matchingDialog.data &&
                      core.matchingDialog.data.name_en
                    "
                  >
                    <v-flex xs6>
                      <div class="FieldTitle">
                        {{ $t("common.name_en") + ":" }}
                      </div>
                      <div>{{ core.matchingDialog.data.name_en }}</div></v-flex
                    >
                    <v-flex xs6
                      ><v-autocomplete
                        ref="name_en"
                        prepend-icon="mdi-arrow-right-thick"
                        :items="tableColumns"
                        v-model="selectedNameEn"
                        clearable
                        solo
                        :menu-props="fieldMatchingOptions"
                        :disabled="
                          currentOpenedMenuMatchingField != null &&
                          currentOpenedMenuMatchingField != 'name_en'
                        "
                        @blur="matchingFieldsBlur('name_en')"
                        @focus="currentOpenedMenuMatchingField = 'name_en'"
                        @click:append="openMenuMatchingField('name_en')"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item @click="core.manageColumnModal = true">
                            <v-list-item-title
                              ><v-icon>add</v-icon
                              >{{ $t("common.matchDialog.createColumn") }}
                            </v-list-item-title>
                          </v-list-item>
                        </template>

                        <template v-slot:no-data>
                          <v-list-item style="display: none"> </v-list-item
                        ></template> </v-autocomplete
                    ></v-flex>
                  </v-layout>

                  <v-layout
                    v-if="
                      core.matchingDialog.data &&
                      core.matchingDialog.data.name_zh
                    "
                  >
                    <v-flex xs6>
                      <div class="FieldTitle">
                        {{ $t("common.name_zh") + ":" }}
                      </div>
                      <div>{{ core.matchingDialog.data.name_zh }}</div></v-flex
                    >
                    <v-flex xs6
                      ><v-autocomplete
                        ref="name_zh"
                        prepend-icon="mdi-arrow-right-thick"
                        :items="tableColumns"
                        v-model="selectedNameTc"
                        clearable
                        solo
                        :menu-props="fieldMatchingOptions"
                        :disabled="
                          currentOpenedMenuMatchingField != null &&
                          currentOpenedMenuMatchingField != 'name_zh'
                        "
                        @blur="matchingFieldsBlur('name_zh')"
                        @focus="currentOpenedMenuMatchingField = 'name_zh'"
                        @click:append="openMenuMatchingField('name_zh')"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item @click="core.manageColumnModal = true">
                            <v-list-item-title
                              ><v-icon>add</v-icon
                              >{{ $t("common.matchDialog.createColumn") }}
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item style="display: none"> </v-list-item
                        ></template> </v-autocomplete
                    ></v-flex>
                  </v-layout>

                  <v-layout
                    v-if="
                      core.matchingDialog.data &&
                      core.matchingDialog.data.address_en
                    "
                  >
                    <v-flex xs6>
                      <div class="FieldTitle">
                        {{ $t("common.address_en") + ":" }}
                      </div>
                      <div>
                        {{ core.matchingDialog.data.address_en }}
                      </div></v-flex
                    >
                    <v-flex xs6
                      ><v-autocomplete
                        ref="address_en"
                        prepend-icon="mdi-arrow-right-thick"
                        :items="tableColumns"
                        v-model="selectedAddressEn"
                        clearable
                        solo
                        :menu-props="fieldMatchingOptions"
                        :disabled="
                          currentOpenedMenuMatchingField != null &&
                          currentOpenedMenuMatchingField != 'address_en'
                        "
                        @blur="matchingFieldsBlur('address_en')"
                        @focus="currentOpenedMenuMatchingField = 'address_en'"
                        @click:append="openMenuMatchingField('address_en')"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item @click="core.manageColumnModal = true">
                            <v-list-item-title
                              ><v-icon>add</v-icon
                              >{{ $t("common.matchDialog.createColumn") }}
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item style="display: none"> </v-list-item>
                        </template> </v-autocomplete
                    ></v-flex>
                  </v-layout>

                  <v-layout v-if="core.matchingDialog.data.address_zh">
                    <v-flex xs6>
                      <div class="FieldTitle">
                        {{ $t("common.address_zh") + ":" }}
                      </div>
                      <div>
                        {{ core.matchingDialog.data.address_zh }}
                      </div></v-flex
                    >
                    <v-flex xs6
                      ><v-autocomplete
                        ref="address_zh"
                        :disabled="
                          currentOpenedMenuMatchingField != null &&
                          currentOpenedMenuMatchingField != 'address_zh'
                        "
                        prepend-icon="mdi-arrow-right-thick"
                        :items="tableColumns"
                        v-model="selectedAddressTc"
                        clearable
                        solo
                        :menu-props="fieldMatchingOptions"
                        @focus="currentOpenedMenuMatchingField = 'address_zh'"
                        @blur="matchingFieldsBlur('address_zh')"
                        @click:append="openMenuMatchingField('address_zh')"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item @click="core.manageColumnModal = true">
                            <v-list-item-title
                              ><v-icon>add</v-icon
                              >{{ $t("common.matchDialog.createColumn") }}
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item style="display: none">
                          </v-list-item> </template></v-autocomplete
                    ></v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn large text @click="core.matchingDialog.visible = false">{{
          $t("common.cancel")
        }}</v-btn>
        <v-btn
          class="addNCopyOKButton"
          large
          color="primary"
          :disabled="
            (!enableCoordinate && !enableMatching) ||
            (enableMatching &&
              !selectedNameTc &&
              !selectedNameEn &&
              !selectedAddressTc &&
              !selectedAddressEn)
          "
          @click="addOrEditTableItem"
          >{{ $t("common.ok") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script src="<%= BASE_URL %>lib/jquery-3.5.1.min.js"></script>
<script src="<%= BASE_URL %>lib/leaflet.js"></script>
<script>
import localforage from "localforage";
export default {
  data() {
    return {
      enableCoordinate: true,
      enableMatching: false,

      selectedNameTc: null,
      selectedNameEn: null,
      selectedAddressTc: null,
      selectedAddressEn: null,
      tour_intervalID: null,

      notAllowBackdropClose: false,

      fieldMatchingOptions: { closeOnClick: true, closeOnContentClick: true },
      currentOpenedMenuMatchingField: null,
    };
  },
  watch: {
    async [`core.matchingDialog.visible`](newVal) {
      if (newVal) {
        // Avoid closing dialog quickly problem when tour is running
        // Check if auto tour is needed to be run
        if ((await localforage.getItem("showAddnCopyDataTour")) !== false) {
          this.notAllowBackdropClose = true;
          setTimeout(() => {
            this.core.tour2.runAddNCopyDataSteps({
              isAdd: !this.core.matchingDialog.isCopy,
            });
            localforage.setItem("showAddnCopyDataTour", false);
          }, 400);
          this.setDialogPersistent();
        }
      }
    },
  },

  computed: {
    showMatchField() {
      if (
        this.core.matchingDialog.data.name_en ||
        this.core.matchingDialog.data.name_zh ||
        this.core.matchingDialog.data.address_en ||
        this.core.matchingDialog.data.address_zh
      ) {
        return true;
      } else {
        return false;
      }
    },

    tableColumns: function () {
      let result = [];
      for (let i = 0; i < this.core.dynamicFields.length; i++) {
        let dynamicField = this.core.dynamicFields[i];
        if (
          dynamicField.type == this.core.GLOBAL.FIELD_TYPES.TEXT ||
          dynamicField.type == this.core.GLOBAL.FIELD_TYPES.TEXTAREA
        ) {
          let disabled = false;
          if (
            dynamicField == this.selectedNameTc ||
            dynamicField == this.selectedNameEn ||
            dynamicField == this.selectedAddressTc ||
            dynamicField == this.selectedAddressEn
          ) {
            disabled = true;
          }

          result.push({
            text: dynamicField.label,
            value: dynamicField,
            disabled: disabled,
          });
        }
      }
      return result;
    },
  },
  methods: {
    openMenuMatchingField(type) {
      this.$refs[type].$refs.input.click();
    },

    matchingFieldsBlur(type) {
      this.currentOpenedMenuMatchingField =
        this.currentOpenedMenuMatchingField == type
          ? null
          : this.currentOpenedMenuMatchingField;
      document.activeElement.blur();
    },

    // Avoid closing dialog quickly problem when tour is running
    setDialogPersistent() {
      this.tour_intervalID = setInterval(() => {
        if ($("#driver-popover-item").length == 0) {
          //if ($(".driver-fix-stacking").length == 0) {
          this.notAllowBackdropClose = false;
          clearInterval(this.tour_intervalID);
          this.tour_intervalID = null;
        } else {
          this.notAllowBackdropClose = true;
        }
      }, 1000);
    },

    resetData() {
      this.enableCoordinate = true;
      this.enableMatching = false;
      this.selectedNameTc = null;
      this.selectedNameEn = null;
      this.selectedAddressTc = null;
      this.selectedAddressEn = null;
    },

    async addOrEditTableItem() {
      document.activeElement.blur();

      if (this.core.matchingDialog.isCopy) {
        if (this.enableMatching) {
          if (this.selectedNameTc) {
            this.core._setValueFromItems(
              this.core.currentSelectedTableItem,
              this.selectedNameTc,
              this.core.matchingDialog.data.name_zh
            );
          }
          if (this.selectedNameEn) {
            this.core._setValueFromItems(
              this.core.currentSelectedTableItem,
              this.selectedNameEn,
              this.core.matchingDialog.data.name_en
            );
          }
          if (this.selectedAddressTc) {
            this.core._setValueFromItems(
              this.core.currentSelectedTableItem,
              this.selectedAddressTc,
              this.core.matchingDialog.data.address_zh
            );
          }
          if (this.selectedAddressEn) {
            this.core._setValueFromItems(
              this.core.currentSelectedTableItem,
              this.selectedAddressEn,
              this.core.matchingDialog.data.address_en
            );
          }
        }

        if (this.enableCoordinate) {
          let layer = this.core.map._layers[
            this.core.currentSelectedTableItem.leaflet_id
          ];

          if (layer) {
            layer.setLatLng(this.core.matchingDialog.data.latLng);
            this.core.updateTableItemGeoJSON(layer);
          } else {
            layer = this.core.createTableMarker(
              this.core.matchingDialog.data.latLng,
              this.core.currentSelectedTableItem.item
            );

            this.core.currentSelectedTableItem.geojson = layer.toGeoJSON();
            this.core.currentSelectedTableItem.leaflet_id = layer._leaflet_id;
            this.core.currentSelectedTableItem.item = null;
          }
        }
      } else {
        //for new

        let properties = {};
        if (this.enableMatching) {
          if (this.selectedNameTc) {
            properties[
              this.selectedNameTc.label
            ] = this.core.matchingDialog.data.name_zh;
          }
          if (this.selectedNameEn) {
            properties[
              this.selectedNameEn.label
            ] = this.core.matchingDialog.data.name_en;
          }
          if (this.selectedAddressTc) {
            properties[
              this.selectedAddressTc.label
            ] = this.core.matchingDialog.data.address_zh;
          }
          if (this.selectedAddressEn) {
            properties[
              this.selectedAddressEn.label
            ] = this.core.matchingDialog.data.address_en;
          }
        }

        if (this.enableCoordinate) {
          //for new: with location
          let layer = this.core.createTableMarker(
            this.core.matchingDialog.data.latLng,
            properties
          );
          await this.core.addItemToTableData(layer);
          this.core.updateCurrentSelectedTableItem({
            tableItem: this.core.getTableItemByLeafletId(layer._leaflet_id),
          });
        } else {
          this.core.currentSelectedTableItem.item = properties;
        }
      }

      this.core.matchingDialog.visible = false;

      if (this.core.currentSelectedTableItem.leaflet_id) {
        this.core.zoomTo({
          leaflet_id: this.core.currentSelectedTableItem.leaflet_id,
          fitBounds: true,
          zoomIn: true,
        });
      }

      if (this.core.matchingDialog.isCopy) {
        this.core.showNewSnackBar(
          this.$t("common.copy") +
            " " +
            this.$t("common.information") +
            " " +
            this.$t("common.successfully")
        );

        //fix ios browser - ui broken when submit add&copy item
        this.setResizeElementTimer(1000);

        if (this.core.matchingDialog.data.resultType == "identify") {
          this.core.$GA.identify_confirmed_copy_item();
        } else if (this.core.matchingDialog.data.resultType == "searchResult") {
          this.core.$GA.sr_confirmed_copy_item();
        }
      } else {
        this.core.showNewSnackBar(
          this.$t("common.insert") +
            " " +
            this.$t("common.record") +
            " " +
            this.$t("common.successfully")
        );

        //fix ios browser - ui broken when submit add&copy item
        this.setResizeElementTimer(1000);

        if (this.core.matchingDialog.data.resultType == "identify") {
          this.core.$GA.identify_confirmed_add_item();
        } else if (this.core.matchingDialog.data.resultType == "searchResult") {
          this.core.$GA.sr_confirmed_add_item();
        }
      }

      this.core.updateCurrentSelectedTableItem({
        tableItem: this.core.currentSelectedTableItem,
      });
      this.core.goToTableItemByIndex({
        index: this.core.currentSelectedTableItem.index,
      });

      this.core.saveDataToLocalStorage();
    },
  },
  props: ["core"],
};
</script>